/**
 * Convert fees to lines
 * @param input input
 */
export function convertFeesToLines(input) {
    const fees = [];
    input.forEach(({ name, nameI18n, percentage, usd, is_tax, online_only }) => {
        fees.push({
            id: `${Math.random()}`.substring(2),
            name,
            nameI18n,
            percentage: parseFloat(percentage),
            usd: parseFloat(usd),
            is_tax: is_tax || false,
            online_only: online_only || false,
        });
    });
    return fees;
}

/**
 * Convert lines to fees
 * @param fees fees
 */
export function convertLinesToFees(fees) {
    const feesValue = [];
    // remove id from fees
    for (let i = 0; i < fees.length; i++) {
        const { id: _id, ...rest } = fees[i];
        // make sure rest percentage and usd are numbers
        rest.percentage = rest.percentage === '' ? 0 : parseFloat(rest.percentage);
        rest.usd = rest.usd === '' ? 0 : parseFloat(rest.usd);
        feesValue.push(rest);
    }
    return feesValue;
}
